import script from "./ITunes.vue?vue&type=script&setup=true&lang=js"
export * from "./ITunes.vue?vue&type=script&setup=true&lang=js"

import "./ITunes.vue?vue&type=style&index=0&id=710ae879&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-710ae879"]])

export default __exports__